export const SETTINGS_INIT = "SETTINGS_INIT";

export const SETTINGS_PASSWORD_DIALOG_HIDE = "SETTINGS_PASSWORD_DIALOG_HIDE";
export const SETTINGS_PASSWORD_DIALOG_SHOW = "SETTINGS_PASSWORD_DIALOG_SHOW";
